<div class="container">
  <aw-toast></aw-toast>
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }

  <div class="title">
    <h2>Admin Dashboard</h2>
    <aw-divider></aw-divider>
  </div>
  <div>
    <div
      cdkDropList
      class="card-container"
      cdkDropListOrientation="mixed"
      (cdkDropListDropped)="drop($event)"
    >
      @for (card of cards; track card.id; let i = $index) {
      <aw-metric-card
        (awDropListDropped)="drop($event)"
        [allowDrag]="allowDrag()"
        [cardInformation]="card.cardInformation"
        [cardData]="card.cardData"
        [cardActions]="card.cardActions"
        cdkDrag
      ></aw-metric-card>
      }
    </div>
  </div>
</div>
